import { getObject } from "../getObjectValue";
class notes {
  constructor(response) {
    this.obj = response?.map((value) => {
      return {
        prescriptionIncomingNoteId: value.prescriptionIncomingNoteId
          ? getObject(value, "prescriptionIncomingNoteId")
          : "",
        prescriptionIncomingId: value.prescriptionIncomingId
          ? getObject(value, "prescriptionIncomingId")
          : "",
        note: value.note ? getObject(value, "note") : "",
        archiveDate: value.archiveDate ? getObject(value, "archiveDate") : null,
        pinNote: value.pinNote ? getObject(value, "pinNote") : false,
        awaitingQuery: value.awaitingQuery
          ? getObject(value, "awaitingQuery")
          : false,
        showOnEntry: value.showOnEntry
          ? getObject(value, "showOnEntry")
          : false,
        showOnHandout: value.showOnHandout
          ? getObject(value, "showOnHandout")
          : false,
        createdOn: value.createdOn ? getObject(value, "createdOn") : "",
      };
    });
  }
}

export default notes;
